<template>
    <div>
        <ResetEmail v-if="!hasToken"/>
        <ResetForm v-if="hasToken" :token="token"/>
    </div>
</template>

<script>
import ResetEmail from "@/components/user/ResetEmail.vue"
import ResetForm from "@/components/user/ResetForm.vue"

export default {
    components: {
        ResetEmail,
        ResetForm
    },
    data() {
        return {
            token: null,
            hasToken: false
        }
    },
    mounted() {
        if (this.$route.params.token.length > 0) {
            this.token = this.$route.params.token
            this.hasToken = true
        }
    }
}
</script>